<template>
  <v-app>
    <idle-timeout
      :idle-timeout="idleTimeout"
      :button-text="this.siteText.ui.sessionTimeoutButtonText"
      :dialog-text="this.siteText.ui.sessionTimeoutMessage"
      @OnWarningTimeout="OnWarningTimeOut"
      v-if="enableIdleTimeout"
    ></idle-timeout>
    <app-error
      v-if="true"
      :error="systemError"
      refresh-button-text="OK"
      @refresh="ReloadApp()"
    ></app-error>
    <v-app-bar app color="primary" height="75">
      <div>
        <v-img
          class="header-image"
          alt="NYDMV Logo"
          contain
          src="@/assets/images/dmv-logo.png"
          max-height="50"
        />
      </div>
      <v-spacer></v-spacer>
      <!-- <div class="red--text">Not Official - Prototype Only</div> -->
      <div class="site-version">V-{{ version }}</div>
    </v-app-bar>
    <v-main>
      <loading-busy
        :loading="loading"
        :isAuthenticating="false"
        text=""
      ></loading-busy>
      <div class="primary--text pa-1 grey lighten-2 d-print-none">
        <h1 class="public-h6 appTitle">{{ siteText.ui.mainHeader }}</h1>
      </div>
      <v-container style="max-width: 1200px" :class="systemError.message ? 'disabled-container' : ''">
        <component 
          :hidden="loading"
          :is="currentComponent"
          ref="child"
          :pageInfo="pageInfo"
          @navigateTo="navigateTo"
        />
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import WelcomePage from './pages/WelcomePage.vue';
import DataCollectionPage from './pages/DataCollectionPage.vue';
import NewReservationPage from './pages/NewReservationPage.vue';
import OtpVerification from './pages/OtpVerification.vue';
import ViewReservationPage from './pages/ViewReservationPage.vue';
import CancelReservationPage from './pages/CancelReservationPage.vue';
import CancelConfirmationPage from './pages/CancelConfirmationPage.vue';
import RescheduleReservationPage from './pages/RescheduleReservationPage.vue';
import SelectServicePage from './pages/SelectServicePage.vue';
import DateOfBirthPage from './pages/DateOfBirthPage.vue';
import SearchLocationPage from './pages/SearchLocationPage.vue';
import SelectLocationPage from './pages/SelectLocationPage.vue';
import SelectLocationCountyPage from './pages/SelectLocationCountyPage.vue';
import SelectAllLocationsPage from './pages/SelectAllLocationsPage.vue';
import SelectDateTimePage from './pages/SelectDateTimePage.vue';
import ConfirmReservationPage from './pages/ConfirmReservationPage.vue';
import LoadingBusy from './components/LoadingBusy.vue';
import siteVersionInfo from './assets/SiteVersionInfo.json';
import MobileCheckInPage from './pages/MobileCheckInPage.vue';
import CheckInTicketPage from './pages/CheckInTicketPage.vue';
import IdleTimeout from './components/IdleTimeout.vue';
import CheckInTicket from './components/CheckInTicket.vue';
import parse from 'url-parse';
import AppError from './components/AppError.vue';

export default {
  name: 'App',

  components: {
    WelcomePage,
    DataCollectionPage,
    NewReservationPage,
    OtpVerification,
    ViewReservationPage,
    CancelReservationPage,
    CancelConfirmationPage,
    RescheduleReservationPage,
    SelectServicePage,
    DateOfBirthPage,
    SearchLocationPage,
    SelectLocationPage,
    SelectLocationCountyPage,
    SelectAllLocationsPage,
    SelectDateTimePage,
    ConfirmReservationPage,
    LoadingBusy,
    MobileCheckInPage,
    CheckInTicketPage,
    IdleTimeout,
    CheckInTicket,
    AppError,
  },

  data: () => ({
    currentComponent: 'WelcomePage',
    pageInfo: null,
    version: siteVersionInfo.VersionNumber,
  }),
  methods: {
    ...mapActions(['getSiteData', 'setTestSiteCode']),
    ...mapActions(['reservationNumber', 'viewTicketGuid']),
    ...mapActions(['setDirectNavigation', 'confirmationNumber']),
    navigateTo(componentName, pageInfo) {
      this.currentComponent = componentName;
      this.pageInfo = pageInfo;

      document.title = process.env.VUE_APP_TITLE;
      if (this.pageInfo && this.pageInfo.pageName) {
        document.title += ' | ' + this.pageInfo.pageName;
      } else if (this.currentComponent == 'WelcomePage') {
        document.title += ' | Welcome Page';
      }

      setTimeout(() => {
        const el = document.getElementById('page-content');
        if (el) {
          el.focus();
        }
      }, 750);
    },
    getConfirmationNumberFromUrl(parameterName) {
      let confirmationNumber = '';
      if (this.parameterExists(parameterName)) {
        confirmationNumber = this.getUrlParameter(parameterName);
      }
      return confirmationNumber;
    },
    isViewBooking() {
      const url = parse(window.location);
      if (url.query.indexOf('v=') > -1) {
        return true;
      }
      return false;
    },
    parameterExists(parameterName) {
      const url = parse(window.location);
      if (url.query.indexOf(`${parameterName}=`) > -1) {
        return true;
      }
      return false;
    },
    getUrlParameter(name) {
      name = name.replace(/[\\[]/, '\\[').replace(/[\]]/, '\\]');
      var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
      var results = regex.exec(location.search);
      return results === null
        ? ''
        : decodeURIComponent(results[1].replace(/\+/g, ' '));
    },
    determineStartPage() {
      let directNavigation = false;
      let confirmationNumber = '';
      let testSiteCode = '';
      let ticketGuid = '';
      let startComponent = 'WelcomePage';

      //Check test site code//
      if (this.parameterExists('tsc')) {
        testSiteCode = this.getUrlParameter('tsc');
        this.setTestSiteCode(testSiteCode);
      }

      if (this.parameterExists('b')) {
        // eslint-disable-next-line no-console
        confirmationNumber = this.getUrlParameter('b');
        startComponent = 'MobileCheckInPage';
      } else if (this.parameterExists('v')) {
        confirmationNumber = this.getUrlParameter('v');
        startComponent = 'ViewReservationPage';
        directNavigation = true;
      } else if (this.parameterExists('r')) {
        directNavigation = true;
        confirmationNumber = this.getUrlParameter('r');
        startComponent = 'RescheduleReservationPage';
      } else if (this.parameterExists('t')) {
        directNavigation = true;
        ticketGuid = this.getUrlParameter('t');
        startComponent = 'CheckInTicketPage';
      }

      this.setDirectNavigation(directNavigation);
      this.currentComponent = startComponent;
      this.reservationNumber({ value: confirmationNumber });
      this.confirmationNumber(confirmationNumber);
      this.viewTicketGuid({ value: ticketGuid });
      console.log(confirmationNumber);
      console.log(ticketGuid);
    },
    OnWarningTimeOut() {
      window.location.reload();
    },
    ReloadApp() {
      window.location.reload();
    },
  },
  computed: {
    ...mapGetters(['siteText']),
    ...mapGetters(['loading']),
    ...mapGetters(['sessionTimeout','systemError']),
    ...mapGetters(['directNavigation']),
    enableIdleTimeout() {
      return !(
        this.currentComponent === 'WelcomePage' ||
        this.currentComponent === 'MobileCheckInPage' ||
        this.directNavigation
      );
    },
    idleTimeout() {
      return this.sessionTimeout * 60;
    },
  },
  async beforeMount() {
    if (this.currentComponent == 'WelcomePage') {
      document.title += ' | Welcome Page';
    }
    await this.getSiteData();
    this.determineStartPage();
  },
};
</script>

<style>
@import './assets/css/publicwebsite.css';
@import 'vue-select/dist/vue-select.css';
</style>

<style scoped>
.appTitle {
  margin-left: 15px;
}

.headerBackground {
  background-image: url('~@/assets/bg-headerDefault.svg');
}
</style>
